module.exports = __webpack_public_path__ + "img/ZWF.cfd88c2a.jpg";